unit PrepareOperationNetItemListType;
{

/* Initial. */

}
interface

uses
  PrepareOperationNetItemType;

type
  TPrepareOperationNetItemListType = array of TPrepareOperationNetItemType;

implementation

end.
